import { ATO_STATES } from '../AtoIncident/constants'
import { CHANGE_INCIDENT_STATE_REQUEST_ASYNC } from '../AtoIncident/Header/constants'

import { CLASSIFICATION_MODAL_CLOSE, CLASSIFICATION_MODAL_OPEN } from './constants'

export default function () {
  const initialState = {
    isShowAccountTakeOverClassificationModal: false,
    state: null,
    incident: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case CLASSIFICATION_MODAL_OPEN: {
        return {
          ...state,
          isShowAccountTakeOverClassificationModal: true,
          state: action.state,
          incident: action.incident,
        }
      }
      // Marking Safe has no post-action confirmation content — keeping the modal open just
      // re-shows the "Are you sure…" copy with a lone Close button, which reads as a redundant
      // popup. Remediate keeps the modal open for its "Account Remediated" step.
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.SUCCESS: {
        if (action.payload?.newState !== ATO_STATES.SAFE) {
          return state
        }
        return { ...initialState }
      }
      case CLASSIFICATION_MODAL_CLOSE:
        return {
          ...state,
          isShowAccountTakeOverClassificationModal: false,
          state: null,
          incident: null,
        }
      default:
        return state
    }
  }
}
